var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _rect6, _rect7, _rect8, _path, _circle3, _path2, _path3, _circle4, _path4, _circle5, _circle6, _path5, _path6, _path7, _path8, _path9, _circle7, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path10, _path11, _rect16, _path12, _path13, _circle8, _path14, _path15, _circle9, _path16, _circle10, _path17, _path18, _circle11, _circle12, _rect17, _rect18, _path19, _path20, _path21, _path22, _rect19, _rect20, _rect21, _path23, _circle13, _path24, _path25, _path26, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path27, _path28, _circle14, _circle15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 327,
    viewBox: "0 0 254 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.0754,
    y: 137.34,
    width: 91.0569,
    height: 32.1969,
    fill: "#1F244D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4678,
    y: 137.34,
    width: 72.4431,
    height: 32.1969,
    fill: "#4B518C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8416,
    y: 15.0923,
    width: 4.02462,
    height: 46.7862,
    fill: "#3D4273"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3323,
    y: 15.0923,
    width: 4.02462,
    height: 46.7862,
    fill: "#8991DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5961,
    cy: 8.80385,
    r: 8.80385,
    fill: "#F2463A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.829,
    cy: 6.54,
    r: 5.53385,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1294,
    y: 31.6938,
    width: 199.722,
    height: 106.149,
    fill: "#1F244D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1294,
    y: 31.6938,
    width: 127.782,
    height: 106.149,
    fill: "#5C63AB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 165.009,
    width: 148.911,
    height: 161.991,
    fill: "#5C63AB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148.911,
    y: 165.009,
    width: 104.137,
    height: 161.991,
    fill: "#1F244D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4048 62.1296C72.4048 71.5692 64.7525 79.2214 55.3129 79.2214C51.1685 79.2214 47.8748 79.2214 47.8748 79.2214C45.9746 71.3637 47.8749 50.3329 47.8749 45.0377C47.8749 45.0377 45.8733 45.0377 55.3129 45.0377C64.7525 45.0377 72.4048 52.69 72.4048 62.1296Z",
    fill: "#F2463A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.4,
    cy: 62.1296,
    r: 17.0919,
    fill: "#F89790"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3143 50.0438C28.6395 56.7186 28.6395 67.5406 35.3143 74.2153L59.4858 50.0438C52.811 43.369 41.9891 43.369 35.3143 50.0438Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.19 197.733C139.19 207.173 131.538 214.825 122.099 214.825C117.954 214.825 114.66 214.825 114.66 214.825C112.76 206.967 114.66 185.936 114.66 180.641C114.66 180.641 112.659 180.641 122.099 180.641C131.538 180.641 139.19 188.293 139.19 197.733Z",
    fill: "#A6A6A6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.204,
    cy: 197.733,
    r: 17.0919,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.118 185.647C98.4437 192.322 98.4437 203.144 105.118 209.819L129.29 185.647C122.615 178.973 111.793 178.973 105.118 185.647Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.965,
    cy: 197.494,
    r: 10.3223,
    stroke: "#4B518C",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.66,
    cy: 61.8784,
    r: 15.6046,
    stroke: "#5C63AB",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2537 99.9534C32.2537 93.5113 38.4609 88.889 44.6328 90.735C62.3648 96.0388 81.1905 96.5172 99.1691 92.121L105.726 90.5176C112.981 88.7436 119.98 94.2371 119.98 101.706C119.98 106.962 116.42 111.552 111.329 112.861L110.412 113.096C87.914 118.879 64.3192 118.879 41.8213 113.096L40.6228 112.788C35.6971 111.522 32.2537 107.082 32.2537 101.996V99.9534Z",
    fill: "#D1D5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4985 117.328V94.8603C87.4337 94.4575 93.3459 93.545 99.1692 92.121L100.112 91.8904V115.328C93.9492 116.418 87.7301 117.085 81.4985 117.328Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1401 89.8573C38.9176 92.089 35.9214 96.5113 35.9214 101.817C35.9214 106.596 38.4321 110.925 42.3725 113.34L40.3986 112.821C35.2694 111.473 31.6938 106.836 31.6938 101.533C31.6938 94.9931 36.9825 89.965 43.1401 89.8573Z",
    fill: "#1F244D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.583 193.182C214.415 193.182 232.925 211.691 232.925 234.524V327H180.605L191.583 193.182Z",
    fill: "#3D4273"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.531 219.342C168.531 204.894 180.243 193.182 194.691 193.182C209.139 193.182 220.851 204.894 220.851 219.342V327H168.531V219.342Z",
    fill: "#5C63AB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.691,
    cy: 231.918,
    r: 15.6046,
    stroke: "#ABB2FF",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4678,
    y: 142.874,
    width: 72.4431,
    height: 2.51538,
    fill: "#8991DC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4678,
    y: 151.929,
    width: 72.4431,
    height: 2.51538,
    fill: "#8991DC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4678,
    y: 160.985,
    width: 72.4431,
    height: 2.51538,
    fill: "#8991DC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 148.911,
    y: 142.874,
    width: 36.2215,
    height: 2.51538,
    fill: "#4B518C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 148.911,
    y: 151.929,
    width: 36.2215,
    height: 2.51538,
    fill: "#4B518C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 148.911,
    y: 160.985,
    width: 36.2215,
    height: 2.51538,
    fill: "#4B518C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5952,
    y: 234.937,
    width: 114.198,
    height: 55.7532,
    rx: 10,
    fill: "#D1D5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1802 234.937C23.6714 234.953 19.2107 239.424 19.2107 244.937V280.69C19.2107 286.213 23.6878 290.69 29.2107 290.69H119.824C119.814 290.69 119.804 290.69 119.794 290.69H25.5952C20.0724 290.69 15.5952 286.213 15.5952 280.69V244.937C15.5952 239.414 20.0724 234.937 25.5952 234.937H29.1802Z",
    fill: "#1F244D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0706 290.69L90.8238 234.937H119.794C122.561 234.937 125.066 236.061 126.877 237.878L74.0639 290.69H35.0706Z",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5952,
    y: 184.126,
    width: 65.9031,
    height: 30.6877,
    rx: 10,
    fill: "#D1D5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5952 184.126C20.0724 184.126 15.5952 188.603 15.5952 194.126V204.814C15.5952 210.337 20.0724 214.814 25.5952 214.814H29.6112C24.0924 214.809 19.62 210.334 19.62 204.814V194.126C19.62 188.603 24.0972 184.126 29.62 184.126H71.5075C71.5044 184.126 71.5014 184.126 71.4983 184.126H25.5952Z",
    fill: "#1F244D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.663 62.1296C128.663 71.5692 121.01 79.2214 111.571 79.2214C107.426 79.2214 104.133 79.2214 104.133 79.2214C102.232 71.3637 104.133 50.3329 104.133 45.0377C104.133 45.0377 102.131 45.0377 111.571 45.0377C121.01 45.0377 128.663 52.69 128.663 62.1296Z",
    fill: "#F2463A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.658,
    cy: 62.1296,
    r: 17.0919,
    fill: "#F89790"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5719 50.0438C84.8971 56.7186 84.8971 67.5406 91.5719 74.2153L115.743 50.0438C109.069 43.369 98.2466 43.369 91.5719 50.0438Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4677 193.878C76.4677 196.485 74.3541 198.599 71.7467 198.599C70.602 198.599 69.6923 198.599 69.6923 198.599C69.1674 196.428 69.6923 190.62 69.6923 189.157C69.6923 189.157 69.1394 189.157 71.7467 189.157C74.3541 189.157 76.4677 191.271 76.4677 193.878Z",
    fill: "#F2463A"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5613,
    cy: 193.878,
    r: 4.72097,
    fill: "#F89790"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4675 205.449C76.4675 208.056 74.3538 210.17 71.7465 210.17C70.6018 210.17 69.692 210.17 69.692 210.17C69.1671 207.999 69.692 202.19 69.692 200.728C69.692 200.728 69.1392 200.728 71.7465 200.728C74.3538 200.728 76.4675 202.841 76.4675 205.449Z",
    fill: "#F2463A"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5611,
    cy: 205.449,
    r: 4.72097,
    fill: "#F89790"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1623 192.178C22.1348 196.205 22.1348 202.735 26.1623 206.762L40.7472 192.178C36.7197 188.15 30.1898 188.15 26.1623 192.178Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7727 194.135C29.6824 193.951 29.9261 193.787 30.0624 193.94L34.7194 199.172C35.1757 199.685 35.0748 200.482 34.5051 200.865C33.9355 201.248 33.159 201.04 32.8568 200.424L29.7727 194.135Z",
    fill: "#F2463A"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.964,
    cy: 199.47,
    r: 8.81308,
    stroke: "#F2463A",
    strokeWidth: 3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4547,
    cy: 199.47,
    r: 8.81308,
    stroke: "#F2463A",
    strokeWidth: 3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 53.3262,
    y: 189.66,
    width: 6.54,
    height: 19.1169,
    fill: "#1F244D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8108,
    y: 189.66,
    width: 6.54,
    height: 19.1169,
    fill: "#8991DC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M168.531 263.109H220.851",
    stroke: "#ABB2FF",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M168.531 288.263H220.851",
    stroke: "#ABB2FF",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.851 263.109H232.925",
    stroke: "#5C63AB",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.851 288.263H232.925",
    stroke: "#5C63AB",
    strokeWidth: 3
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6538,
    y: 243.48,
    width: 92.0815,
    height: 10.08,
    rx: 4.5,
    stroke: "#5C63AB",
    strokeWidth: 3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9031,
    y: 260.091,
    width: 51.3138,
    height: 23.1415,
    fill: "#1F244D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1721,
    y: 260.091,
    width: 81.4985,
    height: 23.1415,
    fill: "#8991DC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.703 271.855C105.703 274.462 103.589 276.576 100.982 276.576C99.8371 276.576 98.9274 276.576 98.9274 276.576C98.4025 274.405 98.9274 268.596 98.9274 267.134C98.9274 267.134 98.3745 267.134 100.982 267.134C103.589 267.134 105.703 269.248 105.703 271.855Z",
    fill: "#F2463A"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.7964,
    cy: 271.855,
    r: 4.72097,
    fill: "#F89790"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7246 264.115L36.7246 279.208",
    stroke: "#32386B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3447 264.115L56.3447 279.208",
    stroke: "#32386B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4678 264.115L76.4678 279.208",
    stroke: "#32386B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7063,
    y: 274.68,
    width: 8.04923,
    height: 3.52154,
    fill: "#1F244D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 32.197,
    y: 274.68,
    width: 8.04923,
    height: 3.52154,
    fill: "#D1D5FF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 52.823,
    y: 265.122,
    width: 8.04923,
    height: 3.52154,
    fill: "#1F244D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 51.314,
    y: 265.122,
    width: 8.04923,
    height: 3.52154,
    fill: "#D1D5FF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 72.946,
    y: 270.152,
    width: 8.04923,
    height: 3.52154,
    fill: "#1F244D"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 71.437,
    y: 270.152,
    width: 8.04923,
    height: 3.52154,
    fill: "#D1D5FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.654 15.0923H192.678V57.8785C192.678 60.0876 190.863 61.8785 188.654 61.8785V15.0923Z",
    fill: "#3D4273"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.145 15.0923H191.169V61.8785C188.96 61.8785 187.145 60.0876 187.145 57.8785V15.0923Z",
    fill: "#8991DC"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.409,
    cy: 8.80385,
    r: 8.80385,
    fill: "#F2463A"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.642,
    cy: 6.54,
    r: 5.53385,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.1a6ccb0a2918edbf2c0b3a615c07a243.svg";
export { ForwardRef as ReactComponent };